import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import Formsy from 'formsy-react';
import axios from 'axios';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as actions from '../../actions';
import Footer from '../index/Footer';
import Header from '../index/Header';
import SimpleField from '../formsy/SimpleField';

const styles = {
	paper: {
		margin: 20,
		marginTop: 40,
		marginBottom: '18%',
		padding: 10,
		height: 400
	},
	container: {
		textAlign: 'center'
	},
	button: {
		textAlign: 'center',
		margin: 30
	}
};

const style = {
	margin: 12
};

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = { canSubmit: false, email: '' };
	}

	disableButton = () => {
		this.setState({ canSubmit: false });
	};

	enableButton = () => {
		this.setState({ canSubmit: true });
	};

	submit = async (email) => {
		const res = await axios.post('/api/contact-us-email', email);
		if (res.data === 'success') {
			this.setState({
				email: 'Thank You, we have received your request.',
				canSubmit: false
			});
		} else {
			this.setState({
				email: 'There was an error with your email. Please try again.',
				canSubmit: true
			});
		}
	};

	renderMessage() {
		return <h5 style={{ color: 'darkorange' }}>{this.state.email}</h5>;
	}

	render() {
		return (
			<div>
				<Header />
				<Paper zDepth={1} style={styles.paper}>
					<div className="container" style={styles.container}>
						{' '}
						<div className="row">
							<h3>Contact Us</h3>
							<h5 style={styles.container}>
								Drop us your email and we'll be in touch!
							</h5>
						</div>
						<Formsy
							onValidSubmit={this.submit}
							onValid={this.enableButton}
							onInvalid={this.disableButton}
						>
							<div className="row">
								<SimpleField
									name="email"
									placeholder="Your Email"
									validations="isEmail"
									required
								/>
								<RaisedButton
									style={style}
									primary
									type="submit"
									label="Submit"
									disabled={!this.state.canSubmit}
								/>
							</div>
							<div className="row">{this.renderMessage()}</div>
						</Formsy>
					</div>
				</Paper>
				<Footer />
			</div>
		);
	}
}

export default connect(null, actions)(withRouter(Login));



// WEBPACK FOOTER //
// ./src/components/index/ContactUs.js